import type { DirectiveBinding } from 'vue';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    el.style.position = 'relative';
    el.style.overflow = 'hidden';

    el.addEventListener('click', (e: MouseEvent) => {
      const ripple: HTMLDivElement = document.createElement('div');

      const rect: DOMRect = el.getBoundingClientRect();
      const size: number = Math.max(rect.width, rect.height);
      const x: number = e.clientX - rect.left - size / 2;
      const y: number = e.clientY - rect.top - size / 2;

      ripple.style.position = 'absolute';
      ripple.style.borderRadius = '50%';
      ripple.style.pointerEvents = 'none';
      ripple.style.width = ripple.style.height = `${size}px`;
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      ripple.style.backgroundColor = binding.value || 'rgba(0,0,0,0.2)';
      ripple.style.opacity = '0.3';
      ripple.style.transform = 'scale(0)';
      ripple.style.transition =
        'transform 400ms ease-out, opacity 400ms ease-out';
      ripple.classList.add('custom-vuetify-ripple');

      el.appendChild(ripple);

      requestAnimationFrame(() => {
        ripple.style.transform = 'scale(2)';
        ripple.style.opacity = '0';
      });

      setTimeout(() => {
        ripple.remove();
      }, 400);
    });
  },
};
